import React from "react";
import { IconButton } from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";

export interface HamburgerButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  size?: "sm" | "md" | "lg";
  variant?: "ghost" | "solid" | "outline";
  borderRadius?: string;
  bgColor?: string;
  boxSize?: number;
  mr?: string | number;
}

const HamburgerButton: React.FC<HamburgerButtonProps> = ({
  onClick,
  ariaLabel = "Open menu",
  size = "sm",
  variant = "ghost",
  borderRadius = "10px",
  bgColor = "white",
  boxSize = 10,
  mr = "16px",
}) => {
  return (
    <IconButton
      borderRadius={borderRadius}
      bgColor={bgColor}
      boxSize={boxSize}
      aria-label={ariaLabel}
      icon={<HamburgerIcon bgColor={"theme.bg.box"} boxSize={8} />}
      variant={variant}
      size={size}
      onClick={onClick}
      mr={mr}
    />
  );
};

export default HamburgerButton;
